import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export interface StructuredDataServiceConfig {
  structuredDataServer: string;
}

export function provideStructuredDataService(config: StructuredDataServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'structuredDataServiceConfig', useValue: config }
  ]);
}
